import { Component, ElementRef, forwardRef, HostListener, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-multi-select',
  imports: [],
  templateUrl: './multi-select.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelect),
      multi: true,
    },
  ],
})
export class MultiSelect implements ControlValueAccessor {
  @Input() placeholder = 'Selecione...';
  @Input() options: { label: string; value: any }[] = [];

  isOpen = false;
  selectedValues: any[] = [];

  constructor(private eRef: ElementRef) {}

  onChange = (val: any) => {};
  onTouched = () => {};

  writeValue(value: any[]): void {
    this.selectedValues = value || [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  isSelected(value: any): boolean {
    return this.selectedValues.includes(value);
  }

  toggleSelection(option: any) {
    if (this.isSelected(option.value)) {
      this.selectedValues = this.selectedValues.filter((v) => v !== option.value);
    } else {
      this.selectedValues.push(option.value);
    }
    this.onChange(this.selectedValues);
  }

  remove(value: any) {
    this.selectedValues = this.selectedValues.filter((v) => v !== value);
    this.onChange(this.selectedValues);
  }

  getLabel(value: any): string {
    return this.options.find((opt) => opt.value === value)?.label || value;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
